// src/features/testimonial/TestimonialSkeleton.tsx

export const TestimonialSkeleton = () => {
  const SkeletonCard = () => (
    <div className="testimonial__item testimonial__item--style1 placeholder-glow">
      <div className="testimonial__item-inner">
        <div className="testimonial__item-content">
          <div className="placeholder col-1 mb-3"></div>
          <div className="placeholder col-12"></div>
          <div className="placeholder col-10"></div>
          <div className="placeholder col-11 mb-4"></div>
          <div className="d-flex align-items-center">
            <div
              className="placeholder rounded-circle"
              style={{ width: '80px', height: '80px' }}
            ></div>
            <div className="ms-3">
              <div className="placeholder col-8"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <section className="testimonial padding-top padding-bottom section-bg-2">
      <div className="container">
        <div className="section-header">
          <div className="section-header__content">
            <h2>What our customers say</h2>
          </div>
        </div>
        <div className="d-flex gap-4 overflow-hidden">
          <SkeletonCard />
          <SkeletonCard />
        </div>
      </div>
    </section>
  );
};
